import ReactGA from 'react-ga4';

export const initGA = (GA_ID: string): void => {
  if (GA_ID) {
    ReactGA.initialize(GA_ID);
  }
};

export const trackEvent = (category: string, action: string, label: string): void => {
  ReactGA?.event && ReactGA.event({
    category,
    action,
    label
  });
};
